interface Tab {
  id: string
  label: string
  count?: number
}

interface TabBarProps {
  tabs: Tab[]
  active: string
  onChange: (id: string) => void
}

export function TabBar({ tabs, active, onChange }: TabBarProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 0,
        borderBottom: '1px solid var(--border)',
        marginBottom: 24,
        animation: 'in-up 400ms var(--ease) 160ms both',
        overflowX: 'auto',
      }}
    >
      {tabs.map(t => {
        const isActive = t.id === active
        return (
          <button
            key={t.id}
            onClick={() => onChange(t.id)}
            style={{
              padding: '12px 16px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: isActive ? 600 : 400,
              color: isActive ? 'var(--text-1)' : 'var(--text-3)',
              fontFamily: 'var(--font)',
              borderBottom: isActive
                ? '2px solid var(--accent)'
                : '2px solid transparent',
              transition: `color var(--dur-f), border-color var(--dur-f)`,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              marginBottom: -1,
              whiteSpace: 'nowrap',
              height: 40,
            }}
            onMouseEnter={e => {
              if (!isActive) e.currentTarget.style.color = 'var(--text-2)'
            }}
            onMouseLeave={e => {
              if (!isActive) e.currentTarget.style.color = 'var(--text-3)'
            }}
          >
            {t.label}
            {t.count !== undefined && (
              <span
                style={{
                  fontSize: 10,
                  fontFamily: 'var(--mono)',
                  padding: '1px 6px',
                  borderRadius: 'var(--r-f)',
                  background: isActive ? 'var(--accent-m)' : 'var(--bg-3)',
                  color: isActive ? 'var(--accent)' : 'var(--text-3)',
                  fontWeight: 600,
                  lineHeight: '14px',
                }}
              >
                {t.count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
